import { withInstall } from '../utils'
import _SwipeItem from './SwipeItem'
import './index.scss'

export const SwipeItem = withInstall(_SwipeItem)
export default SwipeItem
